import React from "react";


import './showImaDetail.css'

const ShowImageDetail = ({showImgDetail, stateImgDetail, urlImage}) =>{

    return(
        <>
            {
                stateImgDetail &&
                <div className="fixed z-50 pt-16 top-0 bottom-0 left-0 bg-white w-full h-full" >
                   <div id="show-image-detail" className=" h-full w-full flex justify-center relative">
                        <div className="absolute right-0">
                            <svg onClick={showImgDetail} xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                            </svg>
                        </div>
                        <img  className="h-auto my-auto w-auto mx-auto"  src={urlImage}   alt="" />
                   </div>
                </div>
            }
        </>
    )
}


export default ShowImageDetail;